import { Member, Vote } from '@wix/ambassador-reviews-v1-enriched-live-site-review/types';
import { Review } from '~reviews/controller/lib/reviews-api-types';

// from https://vaidask4.wixsite.com/store-100/product-page/abstract-abstraction-tote

export const mockReviews = [
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '4602f78d-4b3b-4641-816b-0d06984d64e0',
    content: {
      title: 'Wow',
      body: 'nu va',
      media: [],
      rating: 4,
    },
    createdDate: '2022-04-07T08:04:41.899Z',
    author: {
      id: '85b1734c-d4f5-48f6-abb3-f50730395c0f',
      type: 'VISITOR',
      name: 'Mumu',
    },
    foundHelpful: 0,
    foundUnhelpful: 0,
    helpfulness: 0,
    moderationStatus: 'APPROVED',
    verified: false,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '81cf68f1-d0fb-4ca0-a4b8-e1fe6450a29c',
    content: {
      title: 'Wow',
      body: 'Amazing!',
      media: [
        {
          image: {
            id: '6aa2a2_01677471a01348e782e0e35936e22188~mv2.jpg',
            url: 'media/6aa2a2_01677471a01348e782e0e35936e22188~mv2.jpg',
            height: 3024,
            width: 4032,
            altText: 's-o-c-i-a-l-c-u-t-OjnmCKmzr3A-unsplash.jpg',
            filename: 's-o-c-i-a-l-c-u-t-OjnmCKmzr3A-unsplash.jpg',
          },
        },
      ],
      rating: 5,
    },
    createdDate: '2022-04-06T12:22:11.957Z',
    author: {
      id: '6aa2a2de-7b0d-46dc-9245-cb576bd13df3',
      type: 'MEMBER',
      name: 'Justė Z',
    },
    foundHelpful: 1,
    foundUnhelpful: 1,
    helpfulness: 0,
    moderationStatus: 'APPROVED',
    verified: true,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '2d76e0f5-7212-4067-a651-e91b3873fe78',
    content: {
      title: 'Best!',
      body: 'No like it.',
      media: [
        {
          image: {
            id: '82a0fc_3c17cbc5d99b47f1a94a2ff8541cf1c5~mv2.jpg',
            url: 'media/82a0fc_3c17cbc5d99b47f1a94a2ff8541cf1c5~mv2.jpg',
            height: 830,
            width: 1200,
            altText: 'IMG_1740.JPG',
            filename: 'IMG_1740.JPG',
          },
        },
      ],
      rating: 5,
    },
    createdDate: '2022-03-29T12:52:52.155Z',
    author: {
      id: '324c28db-9a6c-46cd-b565-b9c162276c59',
      type: 'MEMBER',
      name: 'John Smith',
    },
    foundHelpful: 0,
    foundUnhelpful: 0,
    helpfulness: 0,

    moderationStatus: 'APPROVED',

    verified: false,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '02ad692a-534a-4793-83c9-22364e9aec19',
    content: {
      title: 'REALLY loved it',
      body: "Wow, thank you, that's amazing.",
      media: [
        {
          image: {
            id: '6002ea_2036ee7edeeb4b93940124b32376c7cc~mv2.jpg',
            url: 'media/6002ea_2036ee7edeeb4b93940124b32376c7cc~mv2.jpg',
            height: 3024,
            width: 4032,
            altText: 's-o-c-i-a-l-c-u-t-OjnmCKmzr3A-unsplash.jpg',
            filename: 's-o-c-i-a-l-c-u-t-OjnmCKmzr3A-unsplash.jpg',
          },
        },
      ],
      rating: 5,
    },
    createdDate: '2022-03-29T12:48:18.410Z',
    author: {
      id: 'a17366fe-79eb-4913-acef-1adf954cebf0',
      type: 'VISITOR',
      name: 'Kitty Kat',
    },
    foundHelpful: 0,
    foundUnhelpful: 0,
    helpfulness: 0,

    moderationStatus: 'APPROVED',
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: 'cf8fa764-4785-4616-90f6-a25f0bf53e5e',
    content: {
      title: 'AWESOME ❤️',
      body: 'I bought a few of these to give as Christmas gifts and they were a hit! These totes are sturdy, colors are pretty, and its large enough, and I love the soft canvas feel as opposed to the stiffer ones. I also love the 11 inch handle drop which is SO much easier to get on my shoulder. I bought a black one for work because I have a lot to carry and here is where the top zipper feature comes in handy! I can secure my bag before storing in a cubby. I am back to purchase a few more. Highly recommend!',
      media: [],
      rating: 5,
    },
    createdDate: '2022-03-29T10:55:05.794Z',
    author: {
      id: '898fe5cb-dc3c-4f24-81b4-7014f09ecb1f',
      type: 'VISITOR',
      name: 'Kendall Doll',
    },
    foundHelpful: 1,
    foundUnhelpful: 0,
    helpfulness: 1,

    moderationStatus: 'APPROVED',
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '255bb8ed-9a39-4f8a-bb19-16c513aa7cff',
    content: {
      title: 'I would like another style',
      body: "It's a nice bag, but not big enough for me. I like bags that stretch! (see pictures added as a suggestion)\nI'm able to put everything in my bag and I know for a fact that I'll be able to put my 15 inch laptop in there for work. In it I'll have 2 planners, a notepad, large and small plastics packs (1 is for lunch utensils and the other is for my makeup with a comb/brush), a crossbody purse, cellphone, work ID, water bottle and whatever else I need at the time.",
      media: [
        {
          image: {
            id: 'dc9d2c_c82ce66154e14fc5a641783c83a58f4c~mv2.jpg',
            url: 'media/dc9d2c_c82ce66154e14fc5a641783c83a58f4c~mv2.jpg',
            height: 5359,
            width: 3577,
            altText: 'gaelle-marcel-g917EoHF-Ls-unsplash.jpg',
            filename: 'gaelle-marcel-g917EoHF-Ls-unsplash.jpg',
          },
        },
        {
          image: {
            id: 'dc9d2c_5a75a187c70f438585535d59f70454d9~mv2.jpg',
            url: 'media/dc9d2c_5a75a187c70f438585535d59f70454d9~mv2.jpg',
            height: 5359,
            width: 3573,
            altText: 'no-revisions-ixS7UCRJTdM-unsplash.jpg',
            filename: 'no-revisions-ixS7UCRJTdM-unsplash.jpg',
          },
        },
        {
          image: {
            id: 'dc9d2c_6f7c8ed68f6f4fdf96ee9b721e5dcde9~mv2.jpg',
            url: 'media/dc9d2c_6f7c8ed68f6f4fdf96ee9b721e5dcde9~mv2.jpg',
            height: 6240,
            width: 4160,
            altText: 'sinitta-leunen-YaReHIzNdRw-unsplash.jpg',
            filename: 'sinitta-leunen-YaReHIzNdRw-unsplash.jpg',
          },
        },
      ],
      rating: 3,
    },
    createdDate: '2022-04-07T10:51:51.794Z',
    author: {
      id: '285cd0f3-f5b4-4184-8419-142edfedd9dd',
      type: 'VISITOR',
      name: 'Monika Blu',
    },
    foundHelpful: 2,
    foundUnhelpful: 0,
    helpfulness: 2,

    moderationStatus: 'APPROVED',

    verified: true,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '2914e11e-4bf1-49a5-b3fc-ab2821fb69a0',
    content: {
      title: 'I like it, however there could be some improvements!',
      body: 'The zipper is hard to maneuver. Its inside the top of the tote. Otherwise I like the fact that is is big, roomy Maybe one divider inside would help to organize your contents.\nseems sturdy, stays on your shoulder. So many different colors to chose from and reasonably priced.',
      media: [],
      rating: 4,
    },
    createdDate: '2022-03-29T10:47:54.959Z',
    author: {
      id: 'b2ef3329-6a5c-4e0f-b505-d3a3486e040b',
      type: 'VISITOR',
      name: 'Sarah Blake',
    },
    foundHelpful: 0,
    foundUnhelpful: 0,
    helpfulness: 0,

    moderationStatus: 'APPROVED',

    verified: true,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '32aa845d-43c3-4f68-8c76-4401281e9542',
    content: {
      title: 'WOW, how much I love my new bag',
      body: 'Great bag. I unfortunately had to wash it shortly after getting it. I washed it and air dried it and it came out beautifully. It has plenty of space inside. The pockets on the side are a little small for my drinks but it wasn’t a big deal.',
      media: [],
      rating: 5,
    },
    createdDate: '2022-03-29T10:44:48.216Z',
    author: {
      id: '352037bf-7423-4aa4-9ede-26139f298421',
      type: 'VISITOR',
      name: 'Lolita Kur Lita ',
    },
    foundHelpful: 0,
    foundUnhelpful: 2,
    helpfulness: -2,

    moderationStatus: 'APPROVED',

    verified: false,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: 'a17efaec-c0b4-4647-a230-0f2e26b2bdfb',
    content: {
      title: 'I like it, but not all details',
      body: 'I love my pink little (not so little) bag! It’s comfortable to carry and the strap is super adjustable. It’s deep and wide enough to hold books or a tablet.\n\nThe only issue is the pockets. The outside pockets are too tight to fit your phone or keys. The inside pocket is wide but shallow, so stuff keeps falling out into the bag.',
      media: [],
      rating: 4,
    },
    createdDate: '2022-03-29T10:33:53.820Z',
    author: {
      id: 'e44e0afe-9f59-4590-9353-867985eff980',
      type: 'VISITOR',
      name: 'George Cluni',
    },
    foundHelpful: 0,
    foundUnhelpful: 0,
    helpfulness: 0,

    moderationStatus: 'APPROVED',

    verified: false,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: '3155982d-22f3-4f6c-be04-22fcba6cc483',
    content: {
      title: "Wow, it's so artsy and bright",
      body: "This bag is perfect for what I needed it for. We had a couple emergency visits to the ER real late/early morning where one visit ended up with a transport to another hospital and I didn't have a phone charger on me or any necessary items I needed for a hospital stay. I bought this bag to make and emergency bag for us to fill with everything we may need incase this would happen again, we just grab this bag and go. The bag is very sturdy and well made. Has a zipper closer so all items are safe inside. Has a small pocket inside to hold small items. Also has pockets on each sides. Great bag!",
      media: [
        {
          image: {
            id: '949b9b_49e2abf06e2e4d79b10a63e81179aedb~mv2.jpg',
            url: 'media/949b9b_49e2abf06e2e4d79b10a63e81179aedb~mv2.jpg',
            height: 3456,
            width: 5184,
            altText: 'mohadese-marvi-2EoTlY9UBp4-unsplash.jpg',
            filename: 'mohadese-marvi-2EoTlY9UBp4-unsplash.jpg',
          },
        },
      ],
      rating: 5,
    },
    createdDate: '2022-03-29T08:44:01.220Z',
    author: {
      id: '7f39644a-2c5e-4c81-be28-e1d515cf32f7',
      type: 'VISITOR',
      name: 'Mike Mickey',
    },
    foundHelpful: 0,
    foundUnhelpful: 0,
    helpfulness: 0,

    moderationStatus: 'APPROVED',

    verified: true,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
  {
    namespace: 'compid',
    resourceId: 'test-page',
    id: 'b4d484fc-f6bc-45d8-aafc-39117c33301f',
    content: {
      title: 'Lorem Ipsum',
      body: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec ac sapien id enim varius tincidunt. Pellentesque consectetur a lacus a feugiat. Fusce at ex at diam lobortis dapibus. Ut est neque, placerat sed accumsan sit amet, consequat molestie nisi. Fusce eget cursus libero. Praesent convallis velit nibh, in elementum magna semper et. Fusce eros tellus, elementum vitae lacus vel, vehicula ullamcorper elit. Quisque sit amet felis egestas nisl auctor vulputate. Nulla elementum volutpat metus ut efficitur.\n\nNunc vel placerat magna. Integer imperdiet nibh a lectus ullamcorper blandit. Donec nisl mauris, ultricies a quam sed, volutpat vestibulum augue. Mauris libero dolor, aliquet sed faucibus id, sollicitudin vitae ipsum. Ut condimentum augue quis felis pharetra imperdiet. Sed commodo ex sed tellus tempor congue. Nullam eleifend dolor vel ante facilisis, nec fermentum leo aliquam. Donec vel est sed diam ultrices sagittis sed iaculis magna. Aenean sed auctor ligula. Quisque consequat ligula eu velit molestie, vitae venenatis lectus maximus. Curabitur tincidunt vehicula massa, at consequat nibh fringilla lacinia. Orci varius natoque penatibus et magnis dis parturient montes, nascetur ridiculus mus. Duis sit amet lectus est.\n\nMaecenas imperdiet augue eget felis viverra bibendum vitae et leo. Proin feugiat commodo dolor, sit amet aliquet dolor. Duis commodo odio at dui aliquam pretium. Sed ut blandit urna. Aenean id ex at ipsum ornare elementum ultricies eu erat. Nunc non mi metus. Suspendisse venenatis lacinia sem, faucibus ultrices orci bibendum luctus. Sed lacinia nisi orci, id condimentum eros lacinia vel. Vivamus venenatis sem ac efficitur tristique. Praesent malesuada nisi at urna aliquam dapibus. Donec pellentesque quis lectus nec fringilla. Phasellus hendrerit libero non diam volutpat, sed consectetur metus volutpat. Phasellus nulla sem, volutpat sed porta euismod, porta in orci.\n\nInteger porttitor sodales sem, nec pellentesque libero bibendum ac. Proin pellentesque rutrum orci, et iaculis nunc tincidunt sit amet. Maecenas vel ex nisl. Suspendisse aliquam risus nec mauris imperdiet, eu finibus metus pulvinar. Sed at aliquet elit, vitae porta lorem. Curabitur quis magna quam. Cras tristique elit libero, sed luctus libero congue ullamcorper. Aliquam neque diam, posuere in mollis vel, aliquet in nulla. Suspendisse vel nulla non tellus imperdiet aliquet. Etiam pretium pulvinar sollicitudin.\n\nCurabitur commodo purus a erat tempus, ac porta elit lobortis. Etiam et metus a enim viverra consequat. Cras egestas volutpat venenatis. Sed non blandit odio. Donec vitae dolor egestas, tincidunt nisi eget, vestibulum nulla. Vestibulum a velit eu sem suscipit ornare egestas non metus. Mauris rutrum arcu libero, in posuere elit pulvinar sed. Sed nec nibh sit amet nulla scelerisque vulputate. Integer at mi congue, vehicula urna at, dictum orci. Pellentesque convallis rutrum lobortis. Nam tempus viverra metus, sed ornare lectus sollicitudin non. Fusce porttitor.',
      media: [
        {
          image: {
            id: '222a71_7f5c7b197b7b4f9eb228a4831574392a~mv2.jpg',
            url: 'media/222a71_7f5c7b197b7b4f9eb228a4831574392a~mv2.jpg',
            height: 640,
            width: 960,
            altText: 'cat.jpg',
            filename: 'cat.jpg',
          },
        },
        {
          image: {
            id: '222a71_41b2e650c16e4ad5968c9c64d93374d2~mv2.jpg',
            url: 'media/222a71_41b2e650c16e4ad5968c9c64d93374d2~mv2.jpg',
            height: 637,
            width: 960,
            altText: 'fox.jpg',
            filename: 'fox.jpg',
          },
        },
        {
          image: {
            id: '222a71_df699fa611ca4432a27fbec62dacc5dd~mv2.jpg',
            url: 'media/222a71_df699fa611ca4432a27fbec62dacc5dd~mv2.jpg',
            height: 998,
            width: 1500,
            altText: 'goat.jpg',
            filename: 'goat.jpg',
          },
        },
        {
          image: {
            id: 'd96c5d_64a86a45498f4a6b9ae7018afad271f9~mv2.jpg',
            url: 'media/d96c5d_64a86a45498f4a6b9ae7018afad271f9~mv2.jpg',
            height: 720,
            width: 896,
            altText: 'fiat.jpg',
            filename: 'fiat.jpg',
          },
        },
        {
          image: {
            id: 'd96c5d_1cd8a8dd5fa349b4990483a0a9aa791a~mv2.jpg',
            url: 'media/d96c5d_1cd8a8dd5fa349b4990483a0a9aa791a~mv2.jpg',
            height: 639,
            width: 960,
            altText: 'kingfisher.jpg',
            filename: 'kingfisher.jpg',
          },
        },
      ],
      rating: 1,
    },
    createdDate: '2022-04-25T08:30:11.876Z',
    author: {
      id: '6c2960be-60f1-489e-9dd3-614e2acf4496',
      type: 'VISITOR',
      name: 'Cicero',
    },
    foundHelpful: 1,
    foundUnhelpful: 0,
    helpfulness: 1,
    moderationStatus: 'APPROVED',
    reply: {
      content: 'thank you so much!',
      createdDate: '2022-04-26T08:30:11.876Z',
    },
    verified: true,
    currentUserVote: {
      type: 'NEUTRAL',
    },
  },
] as Review[];

export const currentUserVotes: Vote[] = [
  {
    reviewId: '32aa845d-43c3-4f68-8c76-4401281e9542',
    id: '8fe037c2-0c00-433c-b6a9-e58bb3891b2f',
    type: 'DOWNVOTE' as Vote['type'],
  },
  {
    reviewId: '255bb8ed-9a39-4f8a-bb19-16c513aa7cff',
    id: 'f7c311bd-280d-4289-91ea-2de0c36cef78',
    type: 'UPVOTE' as Vote['type'],
  },
];

export const currentMember = {
  id: '9d3f58ee-fb8a-458b-89fb-f59854d2933e',
  loginEmail: 'reviewsuser@test.com',
  status: 'APPROVED',
  contactId: '904a6d11-5471-4668-92a1-becf63d4f61c',
  contact: {
    contactId: '904a6d11-5471-4668-92a1-becf63d4f61c',
    phones: [],
    emails: [],
    addresses: [],
    customFields: {},
  },
  profile: { nickname: 'reviewsuser', slug: 'reviewsuser' },
  privacyStatus: 'PUBLIC',
  activityStatus: 'ACTIVE',
  createdDate: new Date('2022-03-25T13:25:04.000Z'),
  updatedDate: new Date('2022-03-29T11:35:36.005Z'),
} as Member;
